import {useMutation} from '@tanstack/react-query';
import proposalUpdaters from '@/api/updaters/proposals';

function useRejectProposal() {
  return useMutation({
    mutationKey: ['proposals', 'reject'],
    mutationFn: proposalUpdaters.reject,
  });
}

export default useRejectProposal;
